<!--
<h1>{{ title }}</h1>
<nav>
  <a routerLink="/dashboard">처음으로</a>
  <a routerLink="/heroes">Heroes</a>
</nav>
-->
<router-outlet></router-outlet>


<footer>
  <div class="container">
    <p class="copyright">© 2017&nbsp;&nbsp;<a href="http://www.jsd.or.kr/">증산도</a></p>
    <p class="theme-by">* 본 자료는 천지성공 본 책의 요약본입니다. 천지성공은 각 지역 도장 및 서점에서 구하실 수 있습니다.</p>
  </div>
</footer>

